<template>
  <div class="card mb-25 border-0 rounded-0 bg-white daily-sales-box radius-7 heigth-other-cards-dashboard">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing radius-7 total-error-card spacing-cards-dashboard">
      <div>
        <span class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis font-cards-dashboard">Uploads com erro</span>
        <h4 class="fw-black mb-12 lh-1 font-size-32">{{ getDashboardDayCards.total_error }}</h4>
      </div>

      <div>
        <div class="mt-15 mt-md-25 mb-8 mb-md-12 d-flex justify-content-between align-items-center">
          <span class="fw-medium text-secondary">
            <span class="fw-bold text-black">Porcentagem de erro</span>
          </span>
          <span class="fw-semibold font-red">{{ getDashboardDayCards.total_percentage_error }}%</span>
        </div>
  
        <div class="progress" role="progressbar" aria-valuenow="68" aria-valuemin="0" aria-valuemax="100">
          <div class="progress-bar bg-red" :style="{ width: getDashboardDayCards.total_percentage_error + '%' }"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "DashboardDayError",
  data: function () {
    return {
      sales: [
        {
          name: "Sales",
          data: [100, 30, 65, 90, 40, 100, 35],
        },
      ],
      averageDailySalesChart: {
        chart: {
          type: "bar",
          height: 150,
          width: 220,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
            columnWidth: "35%",
            borderRadiusApplication: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#20C7D9"],
        stroke: {
          show: false,
        },
        xaxis: {
          categories: ["Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
          labels: {
            show: false,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: "#607089",
              fontSize: "14px",
              fontWeight: 500,
            },
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          show: false,
          tickAmount: 8,
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: ["#607089"],
              fontSize: "14px",
              fontWeight: 500,
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
          y: {
            formatter: function (val: string) {
              return val + "%";
            },
          },
        },
        grid: {
          show: false,
          strokeDashArray: 5,
          borderColor: "#dfe7f1",
        },
      },
    };
  },
  computed:{
    ...mapGetters([
      'getDashboardDayCards'
    ])
  },
});
</script>
